import { render, staticRenderFns } from "./RestCard.vue?vue&type=template&id=2007fa58"
import script from "./RestCard.vue?vue&type=script&lang=js"
export * from "./RestCard.vue?vue&type=script&lang=js"
import style0 from "./RestCard.vue?vue&type=style&index=0&id=2007fa58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports